import _ from "lodash";
import { queryBuilder } from "@lbs/swarm-client";

import { BonusRuleTypeEnum, BonusRuleBasisEnum } from "@common/constants/enums/bonusRule";

const bonusTypeToBasis = {
  [BonusRuleTypeEnum.TotalWinning]: BonusRuleBasisEnum.Return,
  [BonusRuleTypeEnum.NetWinning]: BonusRuleBasisEnum.Profit,
};

export const generatePredefinedMultipleBonusRule = (multiple) => ({
  AmountPercent: multiple.BonusPercent,
  Basis: bonusTypeToBasis[multiple.BonusType],
  BetType: multiple.BetType,
  MaximumSelections: multiple.Selections.length,
  MinimumSelections: multiple.Selections.length,
  MinBetOdds: 1,
  MinOdds: 1,
  MinBetStakes: {},
});

const camelCaseToUnderscored = (value, key) => _.kebabCase(key).replace(/-/g, "_");

export const changeTicketResultModel = (ticket) => {
  const result = { ...ticket };

  result.SelectionList = result.SelectionList.map((item) => _.mapKeys(item, camelCaseToUnderscored));
  return _.mapKeys(result, camelCaseToUnderscored);
};

export const getPredefinedMultiples = (selectionIds, gameIds) => {
  const builder = queryBuilder()
    .useSource("betting")
    .selectSport(["id", "alias"])
    .selectRegion(["id", "name", "alias"])
    .selectCompetition(["id", "name", "alias"])
    .selectGame(["team1_name", "team2_name", "start_ts"])
    .selectMarket(["name", "base"])
    .selectEvent(["id", "order", "name", "price", "type", "base"])
    .whereGame("id")
    .in(gameIds)
    .whereEvent("id")
    .in(selectionIds);

  return builder.getParams();
};

const BETSLIP_TYPE_EXPRESS = 2;
const BETSLIP_TYPE_SINGLE = 1;

export const createPredefinedBet = (stake, multipleId, selections) => {
  const req = {
    name: "CreateBets",
    params: {
      Bets: [
        {
          InputMethod: 1,
          AcceptTypeId: 0,
          TypeId: selections.length === 1 ? BETSLIP_TYPE_SINGLE : BETSLIP_TYPE_EXPRESS,
          Amount: +stake,
          StateId: 0,
          SelectionList: selections,
          PredefinedMultipleId: multipleId,
        },
      ],
    },
  };

  return req;
};
